<ngx-json-viewer [json]="clinicalMessageContent"></ngx-json-viewer>